import { Route, Routes } from "react-router-dom";
import "./bootstrap.min.css";
import Login from "./screens/Login";
import { Container } from "react-bootstrap";
import Dashboard from "./screens/client/Dashboard.jsx";
import StripeContainer from "./auth/StripeContainer.jsx";
import SuperAdmin from "./screens/admin/SuperAdmin.jsx";
import RequireAuth from "./auth/RequireAuth.jsx";
import RequireAdminAuth from "./auth/RequireAdminAuth.jsx";
import TermsConditions from "./components/Terms&Conditions.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
import Rating from "./components/Rating.jsx";
import ReportDownload from "./components/ReportDownload.jsx";
import Terms from "./screens/Terms.jsx";
import ReceiptDownloadPage from "./components/ReceiptDownloadPage.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import AdminX from "./screens/Admin X/AdminX.jsx";

import "../src/auth/responseDecryption.js";
import { NotificationProvider } from "./components/Notification.jsx";
import ClientOnboardingForm from "./screens/admin/nested-screens/Onboarding-Form/Form.jsx";
import MonthlyReport from "./screens/MonthlyReports/MonthlyReport.jsx";
import NotFound from "./screens/NotFound.jsx";

function App() {
  return (
    <>
      <main>
        <NotificationProvider>
          <Container fluid className="vh-100 p-0 m-0 ">
            <Routes>
              {/* --------------------------------------------- LOGIN PAGE ------------------------------------- */}
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Login />} />
              {/* ----------------------------------------- DASHBOARD  ROUTES ---------------------------------- */}
              <Route
                path="/super-admin"
                element={
                  <RequireAdminAuth>
                    <SuperAdmin />
                  </RequireAdminAuth>
                }
              />
              <Route
                path="/dashboard/adminx"
                element={
                  <RequireAuth>
                    <AdminX />
                  </RequireAuth>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <RequireAuth>
                    <Dashboard />
                  </RequireAuth>
                }
              />
              {/* ------------------------------------------------------------------------------------------------- */}
              <Route
                path="/client/onboarding"
                element={<ClientOnboardingForm />}
              />
              <Route path="/report" element={<MonthlyReport />} />
              <Route path="/download" element={<ReportDownload />} />
              <Route path="/receipt" element={<ReceiptDownloadPage />} />
              <Route path="/rating" element={<Rating />} />
              <Route path="/tipmaidTerms" element={<TermsConditions />}></Route>
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />}></Route>
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/payment" element={<StripeContainer />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Container>
        </NotificationProvider>
      </main>
    </>
  );
}

export default App;
